import { defineStore } from 'pinia';
import { TERMINAL_TYPE } from "../api/enums.js"
import yunxinIM from '../api/yunxinIM.js'

export default defineStore('friendStore', {
	state: () => {
		return {
			friends: [], // 数组用于展示，防止更新时不刷新
			friendMap: new Map(), // map用于查询，提高查询效率
			requests: [] // 好友申请列表
		}
	},
		actions: {
		setFriends(friends) {
			this.friends = friends.map(friend => this.normalizeFriendOnlineFields(friend));
			this.friendMap.clear();
			this.friends.forEach(f => {
				this.addFriendMapKeys(f);
			})
		},
		normalizeFriendOnlineFields(friend = {}) {
			friend.onlineClients = friend.onlineClients || {};
			friend.onlineWeb = !!friend.onlineWeb;
			friend.onlineApp = !!friend.onlineApp;
			friend.online = !!(friend.online || friend.onlineWeb || friend.onlineApp);
			return friend;
		},
		addFriendMapKeys(friend) {
			[friend.id, friend.accountId, friend.imAccid].filter(Boolean).forEach(key => {
				this.friendMap.set(key, friend);
				this.friendMap.set(String(key), friend);
			})
		},
		getFriendAccountId(friend = {}) {
			return friend.imAccid || friend.accountId || friend.accid || friend.id;
		},
		getFriendStatusPayload(friend = {}) {
			return {
				userId: this.getFriendAccountId(friend),
				online: !!friend.online,
				onlineWeb: !!friend.onlineWeb,
				onlineApp: !!friend.onlineApp
			}
		},
		getFriendStatusAccountIds(friends = this.friends) {
			const list = Array.isArray(friends) ? friends : [friends];
			return list
				.filter(friend => friend && !friend.deleted)
				.map(friend => typeof friend === 'object' ? this.getFriendAccountId(friend) : friend)
				.filter(Boolean);
		},
		async subscribeFriendOnlineStatus(friends = this.friends) {
			const accountIds = this.getFriendStatusAccountIds(friends);
			if (!accountIds.length) {
				return;
			}
			await yunxinIM.subscribeUserStatus(accountIds, { immediateSync: true });
		},
		setRequests(requests) {
			this.requests = requests;
		},
		getRequestKey(request) {
			return request.id || `${request.sendId}_${request.recvId}_${request.timestamp || ''}`;
		},
		addRequest(request) {
			const key = this.getRequestKey(request);
			const index = this.requests.findIndex(item => this.getRequestKey(item) == key || (item.sendId == request.sendId && item.recvId == request.recvId));
			if (index >= 0) {
				this.requests.splice(index, 1, { ...this.requests[index], ...request });
			} else {
				this.requests.unshift(request);
			}
		},
		removeRequest(id) {
			for (let idx in this.requests) {
				if (this.requests[idx].id == id || this.getRequestKey(this.requests[idx]) == id) {
					this.requests.splice(idx, 1);
					break;
				}
			}
		},
		removeRequestByAccounts(sendId, recvId) {
			this.requests = this.requests.filter(req => !(req.sendId == sendId && req.recvId == recvId));
		},
		updateFriend(friend) {
			console.log("updateFriend")
			let f = this.findFriend(this.getFriendAccountId(friend)) || this.findFriend(friend.id);
			if (!f) {
				this.addFriend(friend);
				return;
			}
			const status = this.getFriendStatusPayload(f);
			Object.assign(f, friend, status);
			this.addFriendMapKeys(f);
		},
		removeFriend(id) {
			let f = this.findFriend(id);
			if (f) {
				f.deleted = true;
			}
		},
		addFriend(friend) {
			this.normalizeFriendOnlineFields(friend);
			const friendId = this.getFriendAccountId(friend);
			friend.id = friend.id || friendId;
			if (this.findFriend(friendId)) {
				this.updateFriend(friend)
			} else {
				this.friends.unshift(friend);
				this.addFriendMapKeys(friend);
				this.subscribeFriendOnlineStatus(friend).catch(error => {
					console.warn('[friendStore.addFriend] 订阅新好友在线状态失败:', error);
				});
			}
		},
		updateOnlineStatus(onlineData = {}) {
			let friend = this.findFriend(onlineData.userId || onlineData.accountId);
			if (!friend) {
				return;
			}
			const lastLoginIp = onlineData.lastLoginIp || onlineData.loginIp || onlineData.ipAddress || onlineData.ip || onlineData.clientIp;
			const lastLoginArea = onlineData.lastLoginArea || onlineData.loginArea || onlineData.ipArea || onlineData.area;
			if (lastLoginIp) {
				friend.lastLoginIp = lastLoginIp;
			}
			if (lastLoginArea) {
				friend.lastLoginArea = lastLoginArea;
			}
			const hasSdkStatusType = onlineData.statusType !== undefined && onlineData.statusType !== null;
			if (hasSdkStatusType && ![1, 2, 3].includes(Number(onlineData.statusType || 0))) {
				return;
			}
			this.normalizeFriendOnlineFields(friend);
			if (!hasSdkStatusType) {
				if (onlineData.terminal == TERMINAL_TYPE.WEB) {
					friend.onlineWeb = !!onlineData.online;
				}
				if (onlineData.terminal == TERMINAL_TYPE.APP) {
					friend.onlineApp = !!onlineData.online;
				}
				friend.online = !!(friend.onlineWeb || friend.onlineApp);
				return;
			}
			const clientType = String(onlineData.clientType || onlineData.terminal || 'unknown');
			friend.onlineClients = {
				...friend.onlineClients,
				[clientType]: !!onlineData.online
			};
			if (onlineData.isOffline) {
				friend.onlineClients[clientType] = false;
			}
			const webClientTypes = ['4', '16', '64'];
			const appClientTypes = ['1', '2', '65'];
			friend.onlineWeb = webClientTypes.some(type => friend.onlineClients[type]);
			friend.onlineApp = appClientTypes.some(type => friend.onlineClients[type]);
			friend.online = !!(friend.onlineWeb || friend.onlineApp);
		},
		setDnd(id, isDnd) {
			let friend = this.findFriend(id);
			if (friend) {
				friend.isDnd = isDnd;
			}
		},
		setTop(id, isTop) {
			let friend = this.findFriend(id);
			if (friend) {
				friend.isTop = isTop;
			}
		},
		clear() {
			this.friends = [];
			this.friendMap.clear();
			this.requests = [];
		},
		async loadFriend() {
			const friends = await yunxinIM.getFriendList();
			this.setFriends(friends);
			await this.subscribeFriendOnlineStatus();
			const requests = await yunxinIM.getFriendApplications().catch(() => []);
			this.setRequests(requests);
		}
	},
	getters: {
		isFriend: (state) => (userId) => {
			let f = state.findFriend(userId)
			return f && !f.deleted
		},
		findFriend: (state) => (userId) => {
			return state.friendMap.get(userId);
		},
		isInRecvRequest: (state) => (userId) => {
			return state.requests.some((req) => req.recvId == userId);
		},
		isInSendRequest: (state) => (userId) => {
			return state.requests.some((req) => req.sendId == userId);
		}
	}
});
